/*
 * Mask
 *
 * This masks the page underneath the element
 * Used for dialog containers and the like
 *
 * Depends:
 *      jquery.widget.js
 *      mask.css
 *
 * Assumes you are only targeting a single element with your selector and that
 * the element is an immediate child of body
 *
 * Usage:
 *
 * $("#my_dialog").mask();
 *
 *
 */
(function($) {

    $.widget( "ih.mask", {
        options: {
            debug:              false,                              // enable debug in console
            cssClass:           "ih_page_mask",                     // the css class for the mask
            zIndex:             false,                              // int : false to let css handle it
            maskElement:        false,                              // mask over just the element instead of the page
            autoOpen:           true,                               // open mask upon instantiation
            autoDestroy:        true,                               // auto-destroy on close
            autoDestroyDelay:   500,                                // delay allows close animation to finish

            // callbacks
            create:         function(e, obj) { return false; },
            open:           function(e, obj) { return false; },
            close:          function(e, obj) { return false; },
            destroy:        function(e, obj) { return false; }
        },


        _create: function() {
            if ( this.options.debug ) console.log("create mask!");

            // properties
            this.isOpen = false;

            var appendToElement = ( this.options.maskElement ) ? this.element : 'body';

            if ( this.options.debug ) console.log("append to element:", appendToElement);

            this.mask = $("<div />").addClass( this.options.cssClass ).appendTo( appendToElement );

            if ( this.options.autoOpen ) {
                this.open();
            }
        },


        _destroy: function() {
            if ( this.options.debug ) console.log("destroy mask");
            this.mask.remove();

            // callback
            this._trigger("destroy", null, this);
        },


        open: function( event ) {

            if ( this.isOpen ) return false;

            if ( this.options.debug ) console.log("open mask");

            this.mask.addClass( this.options.cssClass + "_open" );
            this.isOpen = true;

            if ( this.options.zIndex ) {
                this.mask.css({ 'z-index': this.options.zIndex });
            }

            // callback
            this._trigger("open", event, this);
        },


        // close
        close: function( event ) {

            // bail out if already closed
            if ( ! this.isOpen ) return false;

            if ( this.options.debug ) console.log("close mask");

            this.mask.removeClass( this.options.cssClass + "_open" );
            this.isOpen = false;

            if ( this.options.zIndex ) {
                this.mask.css({ 'z-index': '' });
            }

            // callback
            this._trigger("close", event, this);

            // allow time for animation to finish
            if ( this.options.autoDestroy ) {
                var $this = this;
                setTimeout( function() {
                    $this.destroy();
                }, $this.options.autoDestroyDelay);
            }
        }


    });

})( jQuery );